// PlantillaCard.jsx
import React, { useState, useEffect } from "react";
import { Button, Modal, Spin, Row, Col, Tag, Drawer, Tooltip } from "antd";
import {
  DownloadOutlined,
  EditOutlined,
  PlusOutlined,
  UploadOutlined,
  FileDoneOutlined,
} from "@ant-design/icons";
import { getFormatoAceptacionPattiById } from "../../../../services/financiero/plandecompras/getFormatoAceptacionPlanCompraPattiService";
import UploadDocumentoFirmadoFormatoAceptacion from "./UploadDocumentoFirmado";
import config from "../../../../config";
import { pdf } from "@react-pdf/renderer";
import PdfDocumentoDelegacion from "../FormatoDelegacionFirmaPlanCompra/pdfDocumentDelegacion";
import PdfDocumentoAceptacion from "./pdfDocumentAceptacion";

import { useSelector } from "react-redux";
import { selectAppPermissions } from "../../../../store/auth/selectors";

const baseUrl = config.baseUrl;

const PlantillaCard = ({
  titulo,
  ComponenteEdicion,
  parametro,
  tipo_formato,
  updateData,
}) => {
  const [modalVisible, setModalVisible] = useState(false);
  const [modalVisibleCargaFormato, setModalVisibleCargaFormato] =
    useState(false);
  const [registroExiste, setRegistroExiste] = useState(null);
  const [registroData, setRegistroData] = useState(null);
  const [loading, setLoading] = useState(true);

  //Control de Permisos
  const appNameFormatos = "formatos_plan_compras_paati";
  const permissionsFormatos = useSelector((state) =>
    selectAppPermissions(state, appNameFormatos)
  );
  const permissionFormatosUpdate = permissionsFormatos.priv_update === "Y";
  const permissionFormatosInsert = permissionsFormatos.priv_insert === "Y";
  const permissionFormatosExport = permissionsFormatos.priv_export === "Y";
  const permissionFormatosPrint = permissionsFormatos.priv_print === "Y";
  const permissionFormatosAccess = permissionsFormatos.priv_access === "Y";

  const fetchRegistro = async () => {
    try {
      setLoading(true);
      const res = await getFormatoAceptacionPattiById(parametro, tipo_formato);
      if (res && res.data) {
        setRegistroExiste(true);
        setRegistroData(res.data);
      } else {
        setRegistroExiste(false);
        setRegistroData(null);
      }
    } catch (err) {
      setRegistroExiste(false);
      setRegistroData(null);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (parametro) {
      fetchRegistro();
    }
  }, [parametro]);

  const handleDescargarCedula = async () => {
    if (registroData?.urlCedula != null) {
      window.open(`${baseUrl}/${registroData?.urlCedula}`, "_blank");
      //Consultar archivo autogenerado
    }
  };

  const handleDescargar = async () => {
    if (registroData?.estado === 1) {
      window.open(`${baseUrl}/${registroData?.urlDescarga}`, "_blank");
    } else {
      if (tipo_formato === 2 && registroData?.detalle?.fecha) {
        const fechaISO = registroData.detalle.fecha;
        const fechaObj = new Date(fechaISO);
        const anio = fechaObj.getFullYear();
        const mes = String(fechaObj.getMonth() + 1).padStart(2, "0");
        const dia = String(fechaObj.getDate()).padStart(2, "0");
        registroData.detalle.fecha = `${anio}-${mes}-${dia}`;
      }

      const detalleCompleto = {
        ...registroData.detalle,
        codigo_interno: registroData.codigo_interno,
      };

      let nombreArchivo = "";
      if (tipo_formato === 1) {
        nombreArchivo = `formato_aceptacion_${registroData.id}.pdf`;
      } else {
        nombreArchivo = `formato_delegacion_${registroData.id}.pdf`;
      }

      const pdfBlob = await generatePdfBlob(detalleCompleto);
      downloadBlob(pdfBlob, nombreArchivo);
    }
  };

  const downloadBlob = (blob, filename) => {
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    link.remove();
    URL.revokeObjectURL(url);
  };

  const generatePdfBlob = async (data) => {
    try {
      let doc;
      if (tipo_formato === 1) {
        doc = <PdfDocumentoAceptacion data={data} />;
      } else {
        doc = <PdfDocumentoDelegacion data={data} />;
      }
      const asPdf = pdf();
      await asPdf.updateContainer(doc); // ⚠️ esta es asíncrona
      const blob = await asPdf.toBlob();
      return blob;
    } catch (error) {
      console.error("❌ Error al generar el PDF:", error);
      return null;
    }
  };

  const handleAbrirModal = () => setModalVisible(true);
  const handleCargaArchivo = () => setModalVisibleCargaFormato(true);
  const actualizarDataRegistoLocal = () => fetchRegistro(parametro);

  const handleCerrarModalCargaArchivo = () => {
    setModalVisibleCargaFormato(false);
    fetchRegistro();
  };

  return (
    <>
      <div style={styles.card}>
        <Row gutter={[16, 8]} style={{ width: "100%" }}>
          <Col xs={24} md={24}>
            <h3 style={styles.titulo}>
              <FileDoneOutlined style={{ marginRight: 8 }} />
              {titulo}
            </h3>
            <p style={{ marginBottom: 4 }}>
              <strong>Estado:</strong>{" "}
              <Tag color={registroData?.estado === 1 ? "green" : "orange"}>
                {registroData?.estado === 1
                  ? "Firmado"
                  : registroExiste === false
                  ? "Pendiente"
                  : "Pendiente"}
              </Tag>
              <strong style={{ marginLeft: 16 }}>Creado:</strong>{" "}
              <span>
                {registroData?.fechaCreacion
                  ? new Date(registroData.fechaCreacion).toLocaleDateString(
                      "es-ES"
                    )
                  : ""}
              </span>
            </p>
          </Col>

          <Col xs={24} md={24}>
            <div style={styles.buttonGroup}>
              {registroExiste &&
                (permissionFormatosPrint || registroData?.estado === 1) && (
                  <Tooltip
                    title={
                      registroData?.estado === 1
                        ? "Descargar documento firmado"
                        : "Descargar documento sin firmar"
                    }
                  >
                    <Button
                      icon={<DownloadOutlined style={{ fontSize: 24 }} />}
                      onClick={handleDescargar}
                      type="default"
                      shape="circle"
                      size="large"
                    />
                  </Tooltip>
                )}

              {tipo_formato === 2 &&
                registroExiste &&
                (registroData?.estado === 1) && (
                  <Tooltip title="Descargar cédula">
                    <Button
                      icon={<DownloadOutlined style={{ fontSize: 24 }} />}
                      onClick={handleDescargarCedula}
                      type="default"
                      shape="circle"
                      size="large"
                    />
                  </Tooltip>
                )}

              {registroData?.estado === 0 && permissionFormatosInsert && (
                <Tooltip title="Cargar Formato">
                  <Button
                    icon={<UploadOutlined style={{ fontSize: 24 }} />}
                    type="default"
                    onClick={handleCargaArchivo}
                    shape="circle"
                    size="large"
                  />
                </Tooltip>
              )}

              {loading ? (
                <Spin style={{ marginTop: 8 }} />
              ) : !registroExiste && permissionFormatosInsert ? (
                <Tooltip title="Crear Formato">
                  <Button
                    icon={<PlusOutlined style={{ fontSize: 24 }} />}
                    type="dashed"
                    onClick={handleAbrirModal}
                    shape="circle"
                    size="large"
                  />
                </Tooltip>
              ) : registroData?.estado === 0 && permissionFormatosUpdate ? (
                <Tooltip title="Editar Formato">
                  <Button
                    icon={<EditOutlined style={{ fontSize: 24 }} />}
                    type="primary"
                    onClick={handleAbrirModal}
                    shape="circle"
                    size="large"
                  />
                </Tooltip>
              ) : null}
            </div>
          </Col>
        </Row>
      </div>

      {/* Modal para carga documento */}

      {registroData && (
        <Modal
          open={modalVisibleCargaFormato}
          onCancel={() => setModalVisibleCargaFormato(false)}
          footer={[
            <Button
              key="close"
              type="primary"
              onClick={() => setModalVisibleCargaFormato(false)}
            >
              Cerrar
            </Button>,
          ]}
          title={
            <div
              style={{
                textAlign: "center",
                fontWeight: "bold",
                fontSize: "30px",
                color: "#004080",
                fontFamily: "Segoe UI, sans-serif",
              }}
            >
              Cargar formato firmado
            </div>
          }
          width={window.innerWidth < 768 ? "100%" : "50vw"}
          styles={{
            padding: 24,
            maxHeight: "calc(100vh - 150px)",
            overflow: "auto",
          }}
          style={{
            top: 40,
          }}
          destroyOnClose
        >
          <UploadDocumentoFirmadoFormatoAceptacion
            id_registro={registroData.id}
            onClose={handleCerrarModalCargaArchivo}
            nombreArchivo={
              tipo_formato === 1
                ? `formato_aceptacion_${registroData.id}.pdf`
                : tipo_formato === 2
                ? `formato_delegacion_${registroData.id}.pdf`
                : `documento_${registroData.id}.pdf`
            }
            tipo_formato={tipo_formato}
            codigo_interno={registroData.codigo_interno}
            updateData={updateData}
          />
        </Modal>
      )}

      {/* Modal Crear/Editar */}
      <Modal
        title={
          <ModalTitle
            title={`${registroExiste ? "✏️ Editar" : "📄 Crear"} - ${titulo}`}
          />
        }
        open={modalVisible}
        onCancel={() => setModalVisible(false)}
        footer={[
          <Button
            key="close"
            type="primary"
            onClick={() => setModalVisible(false)}
          >
            Cerrar
          </Button>,
        ]}
        style={{ top: 0, padding: 0 }}
        width="100vw"
        styles={{
          height: "calc(100vh - 108px)",
          padding: 0,
          overflow: "auto",
        }}
      >
        {ComponenteEdicion && (
          <ComponenteEdicion
            key={modalVisible ? Date.now() : "static"}
            record={parametro}
            existe={registroExiste}
            registroData={registroData}
            onClose={() => setModalVisible(false)}
            actualizarDataRegistoLocal={actualizarDataRegistoLocal}
            updateData={updateData || (() => {})}
          />
        )}
      </Modal>
    </>
  );
};

const ModalTitle = ({ title }) => (
  <div
    style={{
      textAlign: "center",
      fontWeight: "bold",
      fontSize: "28px",
      color: "#004080",
      fontFamily: "Segoe UI, sans-serif",
    }}
  >
    {title}
  </div>
);

const styles = {
  card: {
    border: "1px solid #eee",
    borderRadius: "12px",
    padding: "20px",
    marginBottom: "16px",
    backgroundColor: "#fefefe",
    boxShadow: "0 4px 12px rgba(0,0,0,0.06)",
    width: "100%",
  },
  titulo: {
    fontSize: "18px",
    marginBottom: 8,
    fontWeight: "bold",
    color: "#004080",
  },
  buttonGroup: {
    display: "flex",
    flexDirection: "row", // fila horizontal
    gap: "16px", // espacio entre botones
    justifyContent: "center", // centrar botones horizontalmente
    alignItems: "center",
  },
};

export default PlantillaCard;
